import { useCallback } from 'react';

import { useAaId } from '@trello/authentication';
import { useSharedStateSelector } from '@trello/shared-state';

import type { TraitName, TraitValue } from './traits';
import { useIsOptimizedUserTraitsEnabled } from './useIsOptimizedUserTraitsEnabled';
import { userTraitsSharedState } from './userTraitsSharedState';

export const useUserTrait: (traitName: TraitName) => {
  value: TraitValue | undefined;
  loading: boolean;
} = (traitName: TraitName) => {
  const aaId = useAaId();
  const isOptimizedUserTraitsEnabled = useIsOptimizedUserTraitsEnabled();
  const traitValue = useSharedStateSelector(
    userTraitsSharedState,
    useCallback(
      (traits) => {
        if (!aaId || !isOptimizedUserTraitsEnabled) {
          return { value: undefined, loading: false };
        }

        if (traits[aaId]?.loading) {
          return { value: undefined, loading: true };
        }

        if (!traits[aaId] || traits[aaId]?.attributes.length === 0) {
          return { value: undefined, loading: false };
        }

        return {
          value: traits[aaId]?.attributes.find(
            (trait) => trait.name === traitName,
          )?.value,
          loading: false,
        };
      },
      [aaId, isOptimizedUserTraitsEnabled, traitName],
    ),
  );

  return traitValue;
};
